/* form-header.tsx generated by @compiled/babel-plugin v0.37.1 */
/* eslint-disable @atlaskit/design-system/use-primitives */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ul91osq%7Bmin-width%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1pfhu2gc%7Bmargin-block-start%3Avar(--ds-space-100%2C8px)%7D");
import { type ReactNode } from 'react';
import Heading from '@atlaskit/heading';
interface FormHeaderProps {
  /**
   * Title of the form. This is a header.
   */
  title?: ReactNode;
  /**
   * Description or subtitle of the form.
   */
  description?: ReactNode;
  /**
   * Child content to render in the form below the title and description.
   */
  children?: ReactNode;
}
const formHeaderContentStyles = null;
const formHeaderDescriptionStyles = null;

/**
 * __Form header__.
 *
 * A form header contains the form component's heading and subheadings. This provides the correct padding
 * and styling for it.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */
const FormHeader = ({
  children,
  description,
  title
}: FormHeaderProps): JSX.Element => {
  return <div>
			{title && <Heading size="large">{title}</Heading>}
			{description && <div className={ax(["_1pfhu2gc"])}>{description}</div>}
			{children && <div className={ax(["_1ul91osq _1pfhu2gc"])}>{children}</div>}
		</div>;
};
export default FormHeader;